import { useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { PrimaryButton } from "./shared/PrimaryButton";
import { Footer, LEGAL_LINKS } from "./shared/Footer";

export function LoginScreen() {
  const { signInWithGoogle, authError } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSignIn() {
    setBusy(true);
    setError(null);
    try {
      await signInWithGoogle();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign-in failed.");
    } finally {
      setBusy(false);
    }
  }

  const displayError = error ?? authError;

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "#ffffff" }}>
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-20">
        <div className="max-w-xl text-center">
          <h1
            className="text-5xl sm:text-6xl font-black tracking-tight"
            style={{ color: "#0f0f0f" }}
          >
            Cowboy
          </h1>
          <div className="mt-10 flex flex-col items-center gap-3">
            <PrimaryButton onClick={handleSignIn} disabled={busy}>
              {busy ? "Signing in…" : "Sign in with Google"}
            </PrimaryButton>
            <p className="text-xs max-w-sm" style={{ color: "#71717a" }}>
              By continuing you accept the{" "}
              <a
                href={LEGAL_LINKS.terms}
                target="_blank"
                rel="noreferrer noopener"
                className="underline"
                style={{ color: "#0f0f0f" }}
              >
                Terms
              </a>{" "}
              and{" "}
              <a
                href={LEGAL_LINKS.privacy}
                target="_blank"
                rel="noreferrer noopener"
                className="underline"
                style={{ color: "#0f0f0f" }}
              >
                Privacy Policy
              </a>
              .
              <br />
              <span style={{ color: "#a1a1aa" }}>
                Al continuar aceptas los{" "}
                <a
                  href={LEGAL_LINKS.terms}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="underline"
                  style={{ color: "#71717a" }}
                >
                  Términos
                </a>{" "}
                y la{" "}
                <a
                  href={LEGAL_LINKS.privacy}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="underline"
                  style={{ color: "#71717a" }}
                >
                  Política de privacidad
                </a>
                .
              </span>
            </p>
            {displayError && (
              <p className="text-sm" style={{ color: "#C61418" }}>
                {displayError}
              </p>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
